import { User, CalendarBlank, Stethoscope, Door } from "@phosphor-icons/react";
import { HEBREW_DAYS_FULL, formatHebrewDate } from "../../../utils/dateUtils";
import { getFrequencyLabel } from "../../../utils/appointmentSmsPreview";
import { WIZARD_STEPS } from "./useAppointmentForm";

/**
 * Sticky strip of completed-step chips. Each chip jumps back to its step.
 * Renders nothing until at least one step is complete.
 */
function WizardMiniSummary({
  formData,
  step,
  maxStepReached,
  treatmentTypes,
  accessibleRooms,
  canAccessFinance,
  goToStep,
}) {
  const chips = [];

  const patientDone =
    (formData.patientId || (formData.isTempCustomer && formData.patientName)) &&
    maxStepReached > WIZARD_STEPS.PATIENT;
  if (patientDone && step !== WIZARD_STEPS.PATIENT) {
    chips.push({
      step: WIZARD_STEPS.PATIENT,
      icon: <User size={12} weight="fill" />,
      text: formData.patientName,
    });
  }

  const scheduleDone =
    formData.date && formData.startTime && maxStepReached > WIZARD_STEPS.SCHEDULE;
  if (scheduleDone && step !== WIZARD_STEPS.SCHEDULE) {
    const day = HEBREW_DAYS_FULL[new Date(`${formData.date}T00:00:00`).getDay()];
    const base = `יום ${day} ${formatHebrewDate(new Date(`${formData.date}T00:00:00`), "dd/MM")} · ${formData.startTime}`;
    chips.push({
      step: WIZARD_STEPS.SCHEDULE,
      icon: <CalendarBlank size={12} weight="fill" />,
      text: formData.isRecurring
        ? `${base} · ${getFrequencyLabel(formData.recurringFrequency)} ×${formData.seriesTotalCount}`
        : base,
    });
  }

  const detailsDone = maxStepReached > WIZARD_STEPS.DETAILS;
  if (detailsDone && step !== WIZARD_STEPS.DETAILS) {
    const tt = treatmentTypes.find((t) => t.id === formData.treatmentTypeId);
    const room = accessibleRooms.find((r) => r.id === formData.roomId);
    const parts = [];
    if (tt) parts.push(tt.name);
    if (canAccessFinance && parseFloat(formData.paymentAmount) >= 0 && formData.paymentAmount !== "") {
      parts.push(`₪${parseFloat(formData.paymentAmount).toLocaleString("he-IL")}`);
    }
    if (room) parts.push(room.name);
    if (parts.length > 0) {
      chips.push({
        step: WIZARD_STEPS.DETAILS,
        icon: room ? <Door size={12} weight="fill" /> : <Stethoscope size={12} weight="fill" />,
        text: parts.join(" · "),
      });
    }
  }

  if (chips.length === 0) return null;

  return (
    <div className="apt-wiz-mini-summary">
      {chips.map((chip) => (
        <button
          key={chip.step}
          type="button"
          className="apt-wiz-mini-chip"
          onClick={() => goToStep(chip.step, { fromSummary: step === WIZARD_STEPS.SUMMARY })}
          title="לחיצה לעריכה"
        >
          {chip.icon}
          <span>{chip.text}</span>
        </button>
      ))}
    </div>
  );
}

export default WizardMiniSummary;
